import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import { createTableObj } from 'helpers/common'
import { createSiteForm } from 'helpers/site'
import ActionHelper from 'helpers/action'

// constants
export const SITE_FETCH_LIST = 'site/FETCH_LIST'
export const SUCCESS_SITE_LIST = 'site/SUCCESS_SITE_LIST'
export const CLEAR_SITE_LIST = 'site/CLEAR_SITE_LIST'
export const LOAD_SITE_LIST = 'site/LOAD_SITE_LIST'

export const FETCH_SITE_TABLE = 'site/FETCH_SITE_TABLE'
export const SUCCESS_SITE_TABLE = 'site/SUCCESS_SITE_TABLE'
export const CLEAR_SITE_TABLE = 'site/CLEAR_SITE_TABLE'
export const LOAD_SITE_TABLE = 'site/LOAD_SITE_TABLE'

export const FETCH_SITE_FORM = 'site/FETCH_SITE_FORM'
export const SUCCESS_SITE_FORM = 'site/SUCCESS_SITE_FORM'
export const CLEAR_SITE_FORM = 'site/CLEAR_SITE_FORM'
export const LOAD_SITE_FORM = 'site/LOAD_SITE_FORM'

export const SITE_CHANGE = 'site/CHANGE'
export const SITE_DELETE = 'site/DELETE'
export const SITE_FETCH_LIST_BY_USER = 'site/SITE_FETCH_LIST_BY_USER'
export const [
  SITE_FETCH_LIST_BY_USER_SUCCESS,
  SITE_FETCH_LIST_BY_USER_FAILURE,
] = [`${SITE_FETCH_LIST_BY_USER}_SUCCESS`, `${SITE_FETCH_LIST_BY_USER}_FAILURE`]

export const CLEAR_SITE_STORE = 'site/CLEAR_SITE_STORE'

// actions
export const siteFetchList = ActionHelper.createActionObj(SITE_FETCH_LIST)
export const clearSiteList = ActionHelper.createActionObj(CLEAR_SITE_LIST)
export const fetchSiteTable = ActionHelper.createActionObj(FETCH_SITE_TABLE)
export const clearSiteTable = ActionHelper.createActionObj(CLEAR_SITE_TABLE)
export const fetchSiteForm = ActionHelper.createActionObj(FETCH_SITE_FORM)
export const clearSiteForm = ActionHelper.createActionObj(CLEAR_SITE_FORM)
export const siteChange = ActionHelper.createActionObj(SITE_CHANGE)
export const siteDelete = ActionHelper.createActionObj(SITE_DELETE)
export const siteFetchListByUser = ActionHelper.createActionObj(
  SITE_FETCH_LIST_BY_USER,
)
export const clearSiteStore = ActionHelper.createActionObj(CLEAR_SITE_STORE)

// state
const initialState = () =>
  fromJS({
    loading: true,
    isLoadList: false,
    isLoadTable: false,
    isLoadForm: false,
    listData: [],
    siteData: [],
    tableData: createTableObj(),
    formData: createSiteForm(),
  })

// reducers
const site = handleActions(
  {
    [SUCCESS_SITE_LIST]: (state, action) =>
      state.set('listData', List(action.listData)),
    [CLEAR_SITE_LIST]: state => state.set('listData', List([])),
    [LOAD_SITE_LIST]: (state, action) =>
      state.set('isLoadList', Boolean(action.payload)),

    [SUCCESS_SITE_FORM]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [CLEAR_SITE_FORM]: state => state.set('formData', Map(createSiteForm())),
    [LOAD_SITE_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),

    [SUCCESS_SITE_TABLE]: (state, action) =>
      state.set('tableData', Map(action.tableData)),
    [CLEAR_SITE_TABLE]: state => state.set('tableData', Map(createTableObj())),
    [LOAD_SITE_TABLE]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),

    [SITE_FETCH_LIST_BY_USER_SUCCESS]: (state, action) =>
      state.set('loading', false).set('siteData', List(action.listData)),
    [SITE_FETCH_LIST_BY_USER_FAILURE]: state =>
      state.set('loading', false).set('siteData', []),

    [CLEAR_SITE_STORE]: () => initialState(),
  },
  initialState(),
)

export default site
